/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ListViewLeftPart.sass';

// eslint-disable-next-line react/prefer-stateless-function
class ListViewLeftPart extends Component {
  render() {
    const { arealist, title, descTeaser } = this.props;

    return (
      <div className="leftPart">
        <div className="readMoreContainer">
          <h1 className="main-color bold">
            {title}
          </h1>
        </div>
        <p>
          {descTeaser}
        </p>
        <div className="map-list">
          {arealist.map(elem => (
            <ul key={elem.country_name}>
              <li><strong><a href={elem.country_url}>{elem.country_name}</a></strong></li>
              {elem.provinces.map(province => (
                <div>
                  <ul key={province.province_name}><a href={province.province_url}>{province.province_name}</a></ul>
                  {province.cities.map(city => (
                    <li key={city.city_name}><a href={city.city_url}>{city.city_name}</a></li>
                  ))}
                </div>
              ))}
            </ul>
          ))}
        </div>
      </div>
    );
  }
}

ListViewLeftPart.propTypes = {
  onComponentDidMount: PropTypes.func,
  arealist: PropTypes.arrayOf(PropTypes.shape),
};

ListViewLeftPart.defaultProps = {
  arealist: [],
};


export default ListViewLeftPart;
